export function openModal(dialog: HTMLDialogElement | null) {
    if (dialog) {
        dialog.showModal();
    }
}

export function closeModal(dialog: HTMLDialogElement | null) {
    if (dialog) {
        dialog.close();
    }
}
